import * as React from 'react';

import Typo from 'components/ui/Typo';

import s from './SettingsGroup.module.scss';

type SettingsGroupProps = React.PropsWithChildren<{
  label: string;
}>;

const SettingsGroup: React.FC<SettingsGroupProps> = ({ label, children }) => {
  return (
    <div className={s.root}>
      <Typo view="body-2" color="black" weight="medium">
        {`${label}:`}
      </Typo>
      <div className={s.root__list}>{children}</div>
    </div>
  );
};

export default SettingsGroup;
